import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import L from 'leaflet';
import Hero from '../components/Hero';
import './Home.css';
import Navbar from '../components/Navbar';
import IconTest from '../components/IconTest';
import Footer from '../components/Footer';
import { getNews, getEvents, getFileUrl, getPartners } from '../services/apiService';
import { getExcerpt } from '../utils/htmlUtils';

import primaLogo from '../aseets/images/prima_logo.png';
import slide1img from '../aseets/images/home/slide1.avif';
import slide2img from '../aseets/images/home/slide2.avif';
import slide3img from '../aseets/images/home/slide3.jpg';
import img1 from '../aseets/images/home/img1.jpg';
import img2 from '../aseets/images/home/img2.jpg';
import img3 from '../aseets/images/home/img3.jpg';
import img4 from '../aseets/images/home/img4.jpg';
import img5 from '../aseets/images/home/img5.jpg';
import img6 from '../aseets/images/home/img6.jpg';


// Import CSS Leaflet
import 'leaflet/dist/leaflet.css';

const Home = () => {
  const { t } = useTranslation();
  const [partners, setPartners] = useState([]);
  const [partnersLoading, setPartnersLoading] = useState(true);

  // Fetch partners from database
  useEffect(() => {
    const fetchPartners = async () => {
      try {
        setPartnersLoading(true);
        const data = await getPartners();
        
        // Transform partners data to match expected format
        const transformedPartners = (data || []).map(p => {
          const isCoordinator = p.isCoordinator || false;
          
          // Utiliser directement les données de la base de données
          // Toutes ces données sont maintenant stockées dans la base
          const logo = p.logoUrl ? getFileUrl(p.logoUrl) : (p.logo || '🏢');
          const logoColor = p.logoColor || '#96ca2d';
          const coordinates = p.coordinates || [40, 10]; // Fallback: centre Méditerranée
          const color = p.color || '#96ca2d';
          
          return {
            id: p.id || p.mongoId,
            name: p.name,
            fullName: p.fullName || p.name,
            piName: p.pi || '',
            country: p.country,
            logo: logo,
            logoUrl: p.logoUrl ? getFileUrl(p.logoUrl) : null,
            logoColor: logoColor,
            coordinates: coordinates,
            color: color,
            workPackagesLead: p.workPackagesLead || [],
            workPackagesContributing: p.workPackagesContributing || [],
            workPackage: '', // Legacy field, kept for compatibility
            expertise: p.expertise || p.pi || '',
            website: p.website || '#'
          };
        });
        
        setPartners(transformedPartners);
      } catch (err) {
        console.error('Error fetching partners:', err);
        setPartners([]);
      } finally {
        setPartnersLoading(false);
      }
    };

    fetchPartners();
  }, []);
  
  // Scroll to hash target (e.g., #project-objective) on mount
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const scrollToHash = () => {
      const { hash } = window.location;
      if (!hash) return;
      // Try to find the element and scroll to it
      const target = document.querySelector(hash);
      if (target) {
        setTimeout(() => {
          try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch(_) {}
        }, 0);
      }
    };
    scrollToHash();
  }, []);

  // CARROUSEL INTELLIGENT avec animations automatiques, flèches et curseur
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);

  // Auto-play intelligent du carrousel (pause au survol et drag)
  useEffect(() => {
    if (!isHovered && !isDragging) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % 3);
      }, 4000); // 4 secondes pour voir les animations
      
      return () => clearInterval(interval);
    }
  }, [isHovered, isDragging]);

  // Fonctions pour le drag avec la souris ET le tactile
  const handleStart = (clientX) => {
    setIsDragging(true);
    setStartX(clientX);
    setCurrentX(clientX);
  };

  const handleMove = (clientX) => {
    if (!isDragging) return;
    setCurrentX(clientX);
  };

  const handleEnd = () => {
    if (!isDragging) return;
    
    const deltaX = startX - currentX;
    const threshold = 50; // Seuil minimum pour changer de slide
    
    if (Math.abs(deltaX) > threshold) {
      if (deltaX > 0) {
        // Glisser vers la gauche = slide suivant
        setCurrentSlide((prev) => (prev + 1) % 3);
      } else {
        // Glisser vers la droite = slide précédent
        setCurrentSlide((prev) => (prev - 1 + 3) % 3);
      }
    }
    
    setIsDragging(false);
    setStartX(0);
    setCurrentX(0);
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Événements souris
  const handleMouseDown = (e) => {
    e.preventDefault();
    handleStart(e.clientX);
  };

  const handleMouseMove = (e) => {
    e.preventDefault();
    handleMove(e.clientX);
  };

  const handleMouseUp = (e) => {
    e.preventDefault();
    handleEnd();
  };

  // Événements tactiles
  const handleTouchStart = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    handleStart(touch.clientX);
  };

  const handleTouchMove = (e) => {
    e.preventDefault();
    if (!isDragging) return;
    const touch = e.touches[0];
    handleMove(touch.clientX);
  };

  const handleTouchEnd = (e) => {
    e.preventDefault();
    handleEnd();
  };



  return (
  <>
   <div class="home page-template page-template-page-templates page-template-fullwidth-content page-template-page-templatesfullwidth-content-php page page-id-4059 jet-theme-core jet-theme-core--has-template jet-theme-core--has-header jet-theme-core--has-body jet-theme-core--has-footer layout-fullwidth blog-masonry elementor-default elementor-kit-5747 elementor-page elementor-page-4059"><div id="jet-theme-core-document" class="jet-theme-core-document jet-theme-core-document--elementor-content-type"><div class="jet-theme-core-document__inner">
	
	<Navbar/>
	
	{/* Composant de test des icônes FontAwesome */}
	
	<article id="post-4059" class="post-4059 page type-page status-publish hentry">	
			<div data-elementor-type="wp-page" data-elementor-id="4059" class="elementor elementor-4059">
      <section class="elementor-section elementor-top-section elementor-element elementor-element-ic2p76x elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="ic2p76x" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;5759a04&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
						<div class="elementor-container elementor-column-gap-default">
					<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-im9c73l" data-id="im9c73l" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-0bd4fc3 elementor-widget elementor-widget-jet-slider" data-id="0bd4fc3" data-element_type="widget" data-settings='{"slider_height":{"unit":"px","size":720,"sizes":[]},"_animation":"none","slider_height_tablet":{"unit":"px","size":650,"sizes":[]},"slider_height_mobile":{"unit":"px","size":500,"sizes":[]}}' data-widget_type="jet-slider.default">
				<div class="elementor-widget-container">
					<div class="elementor-jet-slider jet-elements">
						<div 
							id="carouselExampleIndicators" 
							className="carousel slide"
							style={{
								position: 'relative',
								width: '100%',
								height: '720px',
								overflow: 'hidden'
							}}
							onMouseEnter={() => setIsHovered(true)}
							onMouseLeave={() => {
								setIsHovered(false);
								if (isDragging) {
									handleEnd();
								}
							}}
							onMouseDown={handleMouseDown}
							onMouseMove={handleMouseMove}
							onMouseUp={handleMouseUp}
							onTouchStart={handleTouchStart}
							onTouchMove={handleTouchMove}
							onTouchEnd={handleTouchEnd}
						>
							{/* Indicateurs */}
							<ol className="carousel-indicators" style={{
								position: 'absolute',
								bottom: '20px',
								left: '50%',
								transform: 'translateX(-50%)',
								zIndex: 1000,
								display: 'flex',
								gap: '10px',
								listStyle: 'none',
								margin: 0,
								padding: 0
							}}>
								<li 
									className={currentSlide === 0 ? 'active' : ''}
									onClick={() => setCurrentSlide(0)}
									style={{
										width: '12px',
										height: '12px',
										borderRadius: '50%',
										backgroundColor: currentSlide === 0 ? '#96ca2d' : 'rgba(255,255,255,0.5)',
										cursor: 'pointer',
										transition: 'all 0.3s ease',
										border: '2px solid rgba(255,255,255,0.8)'
									}}
								></li>
								<li 
									className={currentSlide === 1 ? 'active' : ''}
									onClick={() => setCurrentSlide(1)}
									style={{
										width: '12px',
										height: '12px',
										borderRadius: '50%',
										backgroundColor: currentSlide === 1 ? '#96ca2d' : 'rgba(255,255,255,0.5)',
										cursor: 'pointer',
										transition: 'all 0.3s ease',
										border: '2px solid rgba(255,255,255,0.8)'
									}}
								></li>
								<li 
									className={currentSlide === 2 ? 'active' : ''}
									onClick={() => setCurrentSlide(2)}
									style={{
										width: '12px',
										height: '12px',
										borderRadius: '50%',
										backgroundColor: currentSlide === 2 ? '#96ca2d' : 'rgba(255,255,255,0.5)',
										cursor: 'pointer',
										transition: 'all 0.3s ease',
										border: '2px solid rgba(255,255,255,0.8)'
									}}
								></li>
							</ol>

							{/* Contenu du carousel */}
							<div className="carousel-inner" style={{
								position: 'relative',
								width: '100%',
								height: '100%',
								overflow: 'hidden'
							}}>
								{/* Slide 1 - MedAgriCycle */}
								<div className={`carousel-item ${currentSlide === 0 ? 'active' : ''}`} style={{
									position: 'absolute',
									top: 0,
									left: 0,
									width: '100%',
									height: '100%',
									opacity: currentSlide === 0 ? 1 : 0,
									transition: 'opacity 1s ease-in-out',
									pointerEvents: currentSlide === 0 ? 'auto' : 'none',
									zIndex: currentSlide === 0 ? 1 : 0
								}}>
									<img 
										className="d-block w-100" 
										src={slide1img} 
										alt="Growing Seedlings" 
										loading="lazy"
										style={{
											width: '100%',
											height: '100%',
											objectFit: 'cover'
										}}
									/>
									<div class="jet-slider__content sp-layer" data-position="centerCenter" data-width="100%" data-height="100%" data-horizontal="0%" data-show-transition="up" data-show-duration="400" data-show-delay="400" style={{
										position: 'absolute',
										top: '50%',
										left: '50%',
										transform: 'translate(-50%, -50%)',
										textAlign: 'center',
										color: 'white',
										width: '100%',
										padding: '0 8px',
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center',
										zIndex: 2
									}}>
										<div class="jet-slider__content-item">
											<div class="jet-slider__content-inner">
												<h5 class="jet-slider__title" style={{ color: 'white' }}>{t('home.carousel.slide1.title')}</h5>
												<h5 class="jet-slider__subtitle" style={{ color: 'white' }}>{t('home.carousel.slide1.subtitle')}</h5>
												
												<div class="prima-logos" >
													<img src={primaLogo} alt="PRIMA Logo" style={{
														height: 'auto',
														maxWidth: '100%',
													}} />
												</div>
												
												<div class="jet-slider__button-wrapper">
													<a className="elementor-button elementor-size-md jet-slider__button jet-slider__button--primary arrow-down" href="#about" title="Scroll down" onClick={(e) => {
														e.preventDefault();
														document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
													}} onTouchStart={(e) => {
														e.preventDefault();
														document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
													}} style={{
														display: 'inline-block',
														backgroundColor: '#96ca2d',
														color: 'white',
														padding: '15px 30px',
														textDecoration: 'none',
														fontSize: '1.1rem',
														fontWeight: 'bold',
														borderRadius:"5px",
														boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
														transition: 'all 0.3s ease',
														touchAction: 'manipulation',
														WebkitTapHighlightColor: 'transparent'
													}}>
														<i aria-hidden="true" className="fas fa-arrow-down"></i>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>

								{/* Slide 2 - Circular Economy */}
								<div className={`carousel-item ${currentSlide === 1 ? 'active' : ''}`} style={{
									position: 'absolute',
									top: 0,
									left: 0,
									width: '100%',
									height: '100%',
									opacity: currentSlide === 1 ? 1 : 0,
									transition: 'opacity 1s ease-in-out',
									pointerEvents: currentSlide === 1 ? 'auto' : 'none',
									zIndex: currentSlide === 1 ? 1 : 0
								}}>
									<img 
										className="d-block w-100" 
										src={slide2img} 
										alt="Short Tree in Field" 
										loading="lazy"
										style={{
											width: '100%',
											height: '100%',
											objectFit: 'cover'
										}}
									/>
									<div class="jet-slider__content sp-layer" data-position="centerCenter" data-width="100%" data-height="100%" data-horizontal="0%" data-show-transition="up" data-show-duration="400" data-show-delay="400" style={{
										position: 'absolute',
										top: '50%',
										left: '50%',
										transform: 'translate(-50%, -50%)',
										textAlign: 'center',
										color: 'white',
										width: '100%',
										padding: '0 8px',
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center',
										zIndex: 2
									}}>
										<div class="jet-slider__content-item">
											<div class="jet-slider__content-inner">
												<h5 class="jet-slider__title" style={{ color: 'white' }}>{t('home.carousel.slide2.title')}</h5>
												<h5 class="jet-slider__subtitle" style={{ color: 'white' }}>{t('home.carousel.slide2.subtitle')}</h5>
												
												<div class="prima-logos" >
													<img src={primaLogo} alt="PRIMA Logo" style={{
													height: 'auto',
													maxWidth: '100%',
													}} />
												</div>
												
												<div class="jet-slider__button-wrapper">
													<a className="elementor-button elementor-size-md jet-slider__button jet-slider__button--primary arrow-down" href="#about" title="Scroll down" onClick={(e) => {
														e.preventDefault();
														document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
													}} onTouchStart={(e) => {
														e.preventDefault();
														document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
													}} style={{
														display: 'inline-block',
														backgroundColor: '#96ca2d',
														color: 'white',
														padding: '15px 30px',
														textDecoration: 'none',
														fontSize: '1.1rem',
														fontWeight: 'bold',
														borderRadius: '5px',
														boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
														transition: 'all 0.3s ease',
														touchAction: 'manipulation',
														WebkitTapHighlightColor: 'transparent'
													}}>
														<i aria-hidden="true" className="fas fa-arrow-down"></i>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>

								{/* Slide 3 - Nature */}
								<div className={`carousel-item ${currentSlide === 2 ? 'active' : ''}`} style={{
									position: 'absolute',
									top: 0,
									left: 0,
									width: '100%',
									height: '100%',
									opacity: currentSlide === 2 ? 1 : 0,
									transition: 'opacity 1s ease-in-out',
									pointerEvents: currentSlide === 2 ? 'auto' : 'none',
									zIndex: currentSlide === 2 ? 1 : 0
								}}>
									<img 
										className="d-block w-100" 
										src={slide3img} 
										alt="Hands Holding Plant" 
										loading="lazy"
										style={{
											width: '100%',
											height: '100%',
											objectFit: 'cover'
										}}
									/>
									<div class="jet-slider__content sp-layer" data-position="centerCenter" data-width="100%" data-height="100%" data-horizontal="0%" data-show-transition="up" data-show-duration="400" data-show-delay="400" style={{
										position: 'absolute',
										top: '50%',
										left: '50%',
										transform: 'translate(-50%, -50%)',
										textAlign: 'center',
										color: 'white',
										width: '100%',
										padding: '0 8px',
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center',
										zIndex: 2
									}}>
										<div class="jet-slider__content-item">
											<div class="jet-slider__content-inner">
												<h5 class="jet-slider__title" style={{ color: 'white' }}>{t('home.carousel.slide3.title')}</h5>
												<h5 class="jet-slider__subtitle" style={{ color: 'white' }}>{t('home.carousel.slide3.subtitle')}</h5>
												
												<div class="prima-logos" >
													<img src={primaLogo} alt="PRIMA Logo" style={{
													height: 'auto',
													maxWidth: '100%',
													}} />
												</div>
												
												<div class="jet-slider__button-wrapper">
													<a className="elementor-button elementor-size-md jet-slider__button jet-slider__button--primary arrow-down" href="#about" title="Scroll down" onClick={(e) => {
														e.preventDefault();
														document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
													}} onTouchStart={(e) => {
														e.preventDefault();
														document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
													}} style={{
														display: 'inline-block',
														backgroundColor: '#96ca2d',
														color: 'white',
														padding: '15px 30px',
														textDecoration: 'none',
														fontSize: '1.1rem',
														fontWeight: 'bold',
														borderRadius: '5px',
														boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
														transition: 'all 0.3s ease',
														touchAction: 'manipulation',
														WebkitTapHighlightColor: 'transparent'
													}}>
														<i aria-hidden="true" className="fas fa-arrow-down"></i>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							{/* Contrôles de navigation */}
							<a 
								className="carousel-control-prev" 
								href="#carouselExampleIndicators" 
								role="button"
								onClick={(e) => {
									e.preventDefault();
									setCurrentSlide(currentSlide === 0 ? 2 : currentSlide - 1);
								}}
								style={{
									position: 'absolute',
									top: '50%',
									left: '20px',
									transform: 'translateY(-50%)',
									width: '50px',
									height: '50px',
									backgroundColor: 'rgba(0, 0, 0, 0.5)',
									borderRadius: '50%',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									zIndex: 1000,
									cursor: 'pointer',
									transition: 'all 0.3s ease',
									textDecoration: 'none'
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
									e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
									e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
								}}
							>
								<span className="carousel-control-prev-icon" aria-hidden="true" style={{
									width: '20px',
									height: '20px',
									backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")`,
									backgroundRepeat: 'no-repeat',
									backgroundPosition: 'center',
									backgroundSize: 'contain'
								}}></span>
								<span className="sr-only" style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Previous</span>
							</a>
							<a 
								className="carousel-control-next" 
								href="#carouselExampleIndicators" 
								role="button"
								onClick={(e) => {
									e.preventDefault();
									setCurrentSlide(currentSlide === 2 ? 0 : currentSlide + 1);
								}}
								style={{
									position: 'absolute',
									top: '50%',
									right: '20px',
									transform: 'translateY(-50%)',
									width: '50px',
									height: '50px',
									backgroundColor: 'rgba(0, 0, 0, 0.5)',
									borderRadius: '50%',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									zIndex: 1000,
									cursor: 'pointer',
									transition: 'all 0.3s ease',
									textDecoration: 'none'
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
									e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
									e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
								}}
							>
								<span className="carousel-control-next-icon" aria-hidden="true" style={{
									width: '20px',
									height: '20px',
									backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")`,
									backgroundRepeat: 'no-repeat',
									backgroundPosition: 'center',
									backgroundSize: 'contain'
								}}></span>
								<span className="sr-only" style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Next</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		</div>
		</div>
		</section>
    {/* About Project Section - Two Column Layout */}
    <section id="about" class="elementor-section elementor-top-section elementor-element elementor-element-89z7kcm elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="89z7kcm" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;1abd0d2&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
						<div id="about-project" class="elementor-container elementor-column-gap-default">
					<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-vm17g8o" data-id="vm17g8o" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
				<div  class="elementor-element elementor-element-ru85lis boolet elementor-widget__width-auto elementor-widget elementor-widget-heading" data-id="ru85lis" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h2 className="elementor-heading-title elementor-size-default">
				<span className="elementor-icon" aria-hidden="true" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
					<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 67 22" fill="none">
						<path d="M56 22C62.0751 22 67 17.0751 67 11C67 4.92487 62.0751 0 56 0C49.9249 0 45 4.92487 45 11C45 17.0751 49.9249 22 56 22Z" fill="#222222"></path>
						<path d="M6.5 17.5C10.0899 17.5 13 14.5899 13 11C13 7.41015 10.0899 4.5 6.5 4.5C2.91015 4.5 0 7.41015 0 11C0 14.5899 2.91015 17.5 6.5 17.5Z" fill="#888888"></path>
					</svg>
				</span>
				{t('home.about.title')}
			</h2>		</div>
				</div>
				<section class="elementor-section elementor-inner-section elementor-element elementor-element-al8yqvv elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="al8yqvv" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;182464d&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
						<div class="elementor-container elementor-column-gap-default">
					<div class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-jmrrob9" data-id="jmrrob9" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-8fmy7ma elementor-widget elementor-widget-image" data-id="8fmy7ma" data-element_type="widget" data-widget_type="image.default">
				<div class="elementor-widget-container">
        <img 
									src={img2} 
									alt="MedAgriCycle Project Background" 
									style={{
										width: '100%',
										height: '100%',
										objectFit: 'cover',
										filter: 'blur(2px) brightness(0.8)'
									}}
								/>
								<div style={{
									position: 'absolute',
									bottom: '30px',
									left: '30px',
									background: 'rgba(255,255,255,0.95)',
									padding: '10px',
									borderRadius: '15px',
									boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
									maxWidth: '400px'
								}}>
									<div style={{
										color: '#2c3e50',
										fontSize: '1.0rem',
										fontWeight: 'bold',
										margin: '0 0 10px 0',
									}}>
										{t('home.about.multidimensional')}
                    	{/* Bottom Row - Project Details */}
						
								<div style={{
									display: 'flex',
									flexDirection: 'column',
									gap: '15px',
									padding: '10px',
									maxWidth: '400px',
								}}>
									{/* Duration */}
									<div style={{
										display: 'flex',
										alignItems: 'center',
										gap: '10px'
									}}>
										<span style={{
											color: '#2c3e50',
											fontSize: '1.0rem',
											fontWeight: 'bold'
										}}>
											{t('home.about.duration')} 
										</span>
										<span style={{
											color: '#2c3e50',
											fontSize: '1.0rem'
										}}>
											{t('home.about.years')}
										</span>
				</div>

									{/* Timeline */}
									<div style={{
										display: 'flex',
										alignItems: 'flex-start',
										gap: '10px'
									}}>
										<span style={{
											color: '#2c3e50',
											fontSize: '1.0rem',
											fontWeight: 'bold'
										}}>
											{t('home.about.timeline')} 
										</span>
										<span style={{
											color: '#2c3e50',
											fontSize: '1.0rem',
											textAlign: 'left'
										}}>
											{t('home.about.dateRange')}
										</span>
					</div>

		</div>
									</div>
								</div>													</div>
				</div>
				</div>
				</div>
				<div class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-n7mpzvk" data-id="n7mpzvk" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
							
				<div class="elementor-element elementor-element-8ea6zbo elementor-widget elementor-widget-text-editor" data-id="8ea6zbo" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
        <span dangerouslySetInnerHTML={{ __html: t('home.about.description') }} />
				</div>
				</div>
				<div class="elementor-element elementor-element-2aae9f3 elementor-widget elementor-widget-text-editor" data-id="2aae9f3" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
        <ol style={{
									lineHeight: '1.6',
									paddingLeft: '20px',
									marginBottom: '30px'
								}}>
									<li>{t('home.about.principles.1')}</li>
									<li>{t('home.about.principles.2')}</li>
									<li>{t('home.about.principles.3')}</li>
									<li>{t('home.about.principles.4')}</li>
									<li>{t('home.about.principles.5')}</li>
									<li>{t('home.about.principles.6')}</li>
								</ol>
				</div>
					</div>
				
					</div>
		</div>
							</div>
		</section>
					</div>
		</div>
							</div>
		</section>
    
   
			
	
				<section id="project-objective" class="elementor-section elementor-top-section elementor-element elementor-element-n45jjue elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="n45jjue" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;ecff0dd&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
						<div class="elementor-container elementor-column-gap-default">
					<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-i3i8o8k" data-id="i3i8o8k" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div  class="elementor-testelementor-element elementor-element-v511525 elementor-widget elementor-widget-heading" data-id="v511525" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h3 className="elementor-heading-title elementor-size-default">
				
				{t('home.objective.title')}
			</h3>
      <br></br>
      <div style={{color:"white" ,fontSize:"20px", textAlign:"center"}} >
      <span dangerouslySetInnerHTML={{ __html: t('home.objective.description') }} />
</div>		</div>
				</div>
			
					</div>
		</div>
							</div>
		</section>

	

				<section class="elementor-section elementor-top-section elementor-element elementor-element-xkyyu3b elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="xkyyu3b" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;e4481a0&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
						<div class="elementor-container elementor-column-gap-default">
					<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-26ooq5j" data-id="26ooq5j" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
				<div class="elementor-element elementor-element-ln9mc3c boolet elementor-widget__width-auto elementor-widget elementor-widget-heading" data-id="ln9mc3c" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h2 className="elementor-heading-title elementor-size-default">
				<span className="elementor-icon" aria-hidden="true" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
					<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 67 22" fill="none">
						<path d="M56 22C62.0751 22 67 17.0751 67 11C67 4.92487 62.0751 0 56 0C49.9249 0 45 4.92487 45 11C45 17.0751 49.9249 22 56 22Z" fill="#222222"></path>
						<path d="M6.5 17.5C10.0899 17.5 13 14.5899 13 11C13 7.41015 10.0899 4.5 6.5 4.5C2.91015 4.5 0 7.41015 0 11C0 14.5899 2.91015 17.5 6.5 17.5Z" fill="#888888"></path>
					</svg>
				</span>
				{t('home.objectives.title')}
			</h2>		</div>
				</div>
				<section class="elementor-section elementor-inner-section elementor-element elementor-element-976gbw3 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="976gbw3" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;b2424c7&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
						<div class="elementor-container elementor-column-gap-default">
					<div class="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-objectives-table" data-id="objectives-table" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-objectives-table-widget elementor-widget elementor-widget-text-editor" data-id="objectives-table-widget" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
					<div className="objectives-table-container">
						<div className="objectives-table-row">
							<div className="objectives-table-cell">
								<img fetchpriority="high" decoding="async" width="240" height="530" src={img4} class="attachment-large size-large wp-image-4633" alt="img"  />
</div>
							<div className="objectives-table-cell">
								<div className="objectives-content-table">
									<div className="objectives-content-row">
										<div className="objectives-content-cell">
											<div className="elementor-image-box-wrapper">
												<div className="elementor-image-box-content">
													<p className="elementor-image-box-title">{t('home.objectives.waterReuse.title')}</p>
													<p className="elementor-image-box-description">{t('home.objectives.waterReuse.description')}</p>
				</div>
		</div>
</div>
										<div className="objectives-content-cell">
											<div className="elementor-image-box-wrapper">
												<div className="elementor-image-box-content">
													<p className="elementor-image-box-title">{t('home.objectives.bioactive.title')}</p>
													<p className="elementor-image-box-description">{t('home.objectives.bioactive.description')}</p>
				</div>
				</div>
</div>
				</div>
									<div className="objectives-content-row">
										<div className="objectives-content-cell">
											<div className="elementor-image-box-wrapper">
												<div className="elementor-image-box-content">
													<p className="elementor-image-box-title">{t('home.objectives.wasteRecycling.title')}</p>
													<p className="elementor-image-box-description">{t('home.objectives.wasteRecycling.description')}</p>
					</div>
</div>
</div>
										<div className="objectives-content-cell">
											<div className="elementor-image-box-wrapper">
												<div className="elementor-image-box-content">
													<p className="elementor-image-box-title">{t('home.objectives.policy.title')}</p>
													<p className="elementor-image-box-description">{t('home.objectives.policy.description')}</p>
												</div>
											</div>
										</div>
									</div>
									<div className="objectives-content-row">
										<div className="objectives-content-cell">
											<div className="elementor-image-box-wrapper">
												<div className="elementor-image-box-content">
													<p className="elementor-image-box-title">{t('home.objectives.protein.title')}</p>
													<p className="elementor-image-box-description">{t('home.objectives.protein.description')}</p>
												</div>
											</div>
										</div>
										<div className="objectives-content-cell">
											<div className="elementor-image-box-wrapper">
												<div className="elementor-image-box-content">
													<p className="elementor-image-box-title">{t('home.objectives.digital.title')}</p>
													<p className="elementor-image-box-description">{t('home.objectives.digital.description')}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				</div>
					</div>
		</div>
							</div>
		</section>
					</div>
		</div>
							</div>
		</section>
		
				
				<section id="consortium" class="elementor-section elementor-top-section elementor-element elementor-element-1d8ycti elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="1d8ycti" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;46c6302&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
						<div class="elementor-container elementor-column-gap-default">
					<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-5yjjyt6" data-id="5yjjyt6" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
				<div  class="elementor-element elementor-element-vrfoeno boolet elementor-widget__width-auto elementor-widget elementor-widget-heading" data-id="vrfoeno" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h2 className="elementor-heading-title elementor-size-default">
				<span className="elementor-icon" aria-hidden="true" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
					<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 67 22" fill="none">
						<path d="M56 22C62.0751 22 67 17.0751 67 11C67 4.92487 62.0751 0 56 0C49.9249 0 45 4.92487 45 11C45 17.0751 49.9249 22 56 22Z" fill="#222222"></path>
						<path d="M6.5 17.5C10.0899 17.5 13 14.5899 13 11C13 7.41015 10.0899 4.5 6.5 4.5C2.91015 4.5 0 7.41015 0 11C0 14.5899 2.91015 17.5 6.5 17.5Z" fill="#888888"></path>
					</svg>
				</span>
				{t('home.consortium.title')}
			</h2>		</div>
				</div>
				<div class="elementor-element elementor-element-052fb50 elementor-widget elementor-widget-jet-testimonials" data-id="052fb50" data-element_type="widget" data-settings="{&quot;slides_to_show&quot;:&quot;3&quot;,&quot;slides_to_show_tablet&quot;:&quot;3&quot;,&quot;slides_to_show_mobile&quot;:&quot;1&quot;,&quot;slides_to_scroll&quot;:&quot;1&quot;}" data-widget_type="jet-testimonials.default">
				<div class="elementor-widget-container">
			<div class="elementor-jet-testimonials jet-elements">
      <MedAgriCycleMap partnersData={partners} partnersLoading={partnersLoading} />


</div>		</div>
				</div>
					</div>
		</div>
							</div>
		</section>

				
				<section id="news" class="elementor-section elementor-top-section elementor-element elementor-element-5zcfz9z elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="5zcfz9z" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;240ea7f&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
						<div class="elementor-container elementor-column-gap-default">
					<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-w8w09l6" data-id="w8w09l6" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
							
				<div  class="elementor-element elementor-element-f7u1jy5 boolet elementor-widget__width-auto elementor-widget elementor-widget-heading" data-id="f7u1jy5" data-element_type="widget" data-widget_type="heading.default" style={{ width: '100%' }}>
				<div class="elementor-widget-container" style={{ width: '100%' }}>
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px', width: '100%' }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
							<h2 className="elementor-heading-title elementor-size-default" style={{ margin: 0 }}>
								<span className="elementor-icon" aria-hidden="true" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
								<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 67 22" fill="none">
									<path d="M56 22C62.0751 22 67 17.0751 67 11C67 4.92487 62.0751 0 56 0C49.9249 0 45 4.92487 45 11C45 17.0751 49.9249 22 56 22Z" fill="#222222"></path>
									<path d="M6.5 17.5C10.0899 17.5 13 14.5899 13 11C13 7.41015 10.0899 4.5 6.5 4.5C2.91015 4.5 0 7.41015 0 11C0 14.5899 2.91015 17.5 6.5 17.5Z" fill="#888888"></path>
								</svg>
							</span>
								{t('home.news.title')}
							</h2>
		</div>
						<Link to="/news" onClick={() => scrollToTop()} style={{
							display: 'inline-flex',
							alignItems: 'center',
							gap: '8px',
							padding: '2px 16px',
							background: 'transparent',
							color: '#96ca2d',
							borderRadius: '50px',
							border: '1px solid #96ca2d',
							transition: 'background 0.2s ease, color 0.2s ease',
							textDecoration: 'none',
							fontWeight: 700,
							whiteSpace: 'nowrap'
						}}
						onMouseEnter={(e) => { e.currentTarget.style.background = '#96ca2d'; e.currentTarget.style.color = '#fff'; }}
						onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#96ca2d'; }}
						onFocus={(e) => { e.currentTarget.style.background = '#96ca2d'; e.currentTarget.style.color = '#fff'; }}
						onBlur={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#96ca2d'; }}
						>
							{t('home.news.visitAll')}
							<span aria-hidden="true" style={{ display: 'inline-flex' }}>
								<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
							</span>
						</Link>
				</div>
				</div>
				</div>
				<div class="elementor-element elementor-widget elementor-widget-jet-posts" data-id="oonvfbx" data-element_type="widget" data-settings="{&quot;columns_tablet&quot;:&quot;2&quot;,&quot;columns_mobile&quot;:&quot;1&quot;,&quot;columns&quot;:3,&quot;slides_to_scroll&quot;:&quot;1&quot;}" data-widget_type="jet-posts.default">
				<div class="elementor-widget-container">
					<LatestNews />
</div>
</div>
					</div>
		</div>
							</div>
		</section>

		{/* Latest Events Section */}
		<section id="events" class="elementor-section elementor-section-events elementor-top-section elementor-element elementor-element-5zcfz9z elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="5zcfz9z" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;240ea7f&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
			<div class="elementor-container elementor-column-gap-default">
					<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-w8w09l6" data-id="w8w09l6" data-element_type="column">
					<div class="elementor-widget-wrap elementor-element-populated">
							
				<div  class="elementor-element elementor-element-f7u1jy5 boolet elementor-widget__width-auto elementor-widget elementor-widget-heading" data-id="f7u1jy5" data-element_type="widget" data-widget_type="heading.default" style={{ width: '100%' }}>
							<div class="elementor-widget-container" style={{ width: '100%' }}>
								<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px', width: '100%' }}>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
							<h2 className="elementor-heading-title elementor-size-default" style={{ margin: 0 }}>
								<span className="elementor-icon" aria-hidden="true" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 67 22" fill="none">
												<path d="M56 22C62.0751 22 67 17.0751 67 11C67 4.92487 62.0751 0 56 0C49.9249 0 45 4.92487 45 11C45 17.0751 49.9249 22 56 22Z" fill="#222222"></path>
												<path d="M6.5 17.5C10.0899 17.5 13 14.5899 13 11C13 7.41015 10.0899 4.5 6.5 4.5C2.91015 4.5 0 7.41015 0 11C0 14.5899 2.91015 17.5 6.5 17.5Z" fill="#888888"></path>
											</svg>
										</span>
								{t('home.events.title')}
							</h2>
									</div>
									<Link to="/events" onClick={() => scrollToTop()} style={{
										display: 'inline-flex',
										alignItems: 'center',
										gap: '8px',
										padding: '2px 16px',
										background: '#fff',
										color: ' #96ca2d',
										borderRadius: '50px',
										border: '1px solid #96ca2d',
										transition: 'background 0.2s ease, color 0.2s ease',
										textDecoration: 'none',
										fontWeight: 700,
										whiteSpace: 'nowrap'
									}}
									onMouseEnter={(e) => { e.currentTarget.style.background = '#96ca2d'; e.currentTarget.style.color = '#fff'; }}
						onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#96ca2d'; }}
						onFocus={(e) => { e.currentTarget.style.background = '#96ca2d'; e.currentTarget.style.color = '#fff'; }}
						onBlur={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#96ca2d'; }}
									>
										{t('home.news.visitAll')}
										<span aria-hidden="true" style={{ display: 'inline-flex' }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
										</span>
									</Link>
								</div>
							</div>
						</div>
						<div class="elementor-element elementor-widget elementor-widget-jet-posts" data-id="oonvfbx" data-element_type="widget" data-settings="{&quot;columns_tablet&quot;:&quot;2&quot;,&quot;columns_mobile&quot;:&quot;1&quot;,&quot;columns&quot;:3,&quot;slides_to_scroll&quot;:&quot;1&quot;}" data-widget_type="jet-posts.default">
							<div class="elementor-widget-container">
								<LatestEvents />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
 
	
							</div>
		</article>

		{/* Carte Géographique Interactive MedAgriCycle */}

		<Footer/>
		</div></div></div>
  </>
);
};

// Composant de carte géographique Leaflet avec partenaires MedAgriCycle
const MedAgriCycleMap = ({ partnersData = [], partnersLoading = false }) => {
  const { t } = useTranslation();
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [hoveredPartner, setHoveredPartner] = useState(null);
  const [mapLoading, setMapLoading] = useState(true);
  const [viewportWidth, setViewportWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);
  const isMobile = viewportWidth <= 768;

  // Use partners from database (partnersData prop) or fallback to empty array
  // The partners data is already transformed in the parent component
  const partners = partnersData && partnersData.length > 0 ? partnersData : [];

  // Work Package metadata for display in details panel
  const wpMeta = {
    WP0: { title: 'Project Coordination and Management', lead: 'ERU (Türkiye)', personMonths: '10', startMonth: '1' },
    WP1: { title: 'Desk Analysis and Living Labs (LL)', lead: 'ERU (Türkiye)', personMonths: '22.2', startMonth: '1' },
    WP2: { title: 'Developing a Digital Toolbox for Urban Agriculture', lead: 'JASSP SAS, URCA (France)', personMonths: '30', startMonth: '1' },
    WP3: { title: 'Reusing Irrigation Water and Effective Irrigation', lead: 'ERU (Türkiye)', personMonths: '50', startMonth: '1' },
    WP4: { title: 'Composting from Agricultural and Urban Waste', lead: 'USMS (Morocco)', personMonths: '30', startMonth: '6' },
    WP5: { title: 'Extraction of High-Value Plant Proteins from Agricultural Waste', lead: 'METU (Türkiye)', personMonths: '24.8', startMonth: '6' },
    WP6: { title: 'Extraction of Economically Significant Food Additives from Agricultural Waste', lead: 'TUBITAK MRC (Türkiye)', personMonths: '7.2', startMonth: '6' },
    WP7: { title: 'Policy Recommendations for Urban Agriculture', lead: 'ERU (Türkiye)', personMonths: '7', startMonth: '12' },
    WP8: { title: 'Dissemination, Exploitation, Communication, and Outreach', lead: 'ERU (Türkiye)', personMonths: '22.2', startMonth: '1' }
  };

  // Lead and contributing partners per WP (from the provided description)
  const wpAssignments = {
    WP0: { 
      lead: ['ERU'], 
      contributors: ['METU', 'TÜBİTAK MRC', 'TUBITAK MRC', 'USMS', 'ENAM', 'JASSP SAS', 'JAPSS', 'URCA', 'INRGREF', 'SRTA-City', 'UNICT'] 
    },
    WP1: { 
      lead: ['ERU'], 
      contributors: ['TÜBİTAK MRC', 'TUBITAK MRC', 'METU', 'USMS', 'ENAM', 'JAPSS', 'URCA', 'INRGREF', 'SRTA-City', 'UNICT'] 
    },
    WP2: { 
      lead: ['JASSP SAS', 'URCA'], 
      contributors: [] 
    },
    WP3: { 
      lead: ['ERU'], 
      contributors: ['USMS', 'INRGREF', 'SRTA-City', 'UNICT'] 
    },
    WP4: { 
      lead: ['USMS'], 
      contributors: ['ERU', 'ENAM', 'INRGREF'] 
    },
    WP5: { 
      lead: ['METU'], 
      contributors: ['ERU'] 
    },
    WP6: { 
      lead: ['TÜBİTAK MRC', 'TUBITAK MRC'], 
      contributors: [] 
    },
    WP7: { 
      lead: ['ERU'], 
      contributors: ['USMS', 'INRGREF'] 
    },
    WP8: { 
      lead: ['ERU'], 
      contributors: ['TÜBİTAK MRC', 'TUBITAK MRC', 'METU', 'USMS', 'ENAM', 'JAPSS', 'JASSP SAS', 'URCA', 'INRGREF', 'SRTA-City', 'UNICT'] 
    }
  };

  const getLeadWPsForPartner = (partnerName) => {
    const normalized = partnerName.toUpperCase().trim();
    return Object.keys(wpAssignments)
      .filter(wp => {
        const leads = wpAssignments[wp].lead.map(n => n.toUpperCase().trim());
        return leads.some(lead => {
          return normalized === lead || 
                 normalized.includes(lead) || 
                 lead.includes(normalized) ||
                 (normalized.includes('TUBITAK') && lead.includes('TUBITAK')) ||
                 (normalized.includes('JASSP') && lead.includes('JASSP'));
        });
      })
      .filter(wp => normalized === 'ERU' || wp !== 'WP8');
  };

  const getContribWPsForPartner = (partnerName) => {
    const normalized = partnerName.toUpperCase().trim();
    return Object.keys(wpAssignments)
      .filter(wp => {
        const contribs = wpAssignments[wp].contributors.map(n => n.toUpperCase().trim());
        return contribs.some(contrib => {
          return normalized === contrib || 
                 normalized.includes(contrib) || 
                 contrib.includes(normalized) ||
                 (normalized.includes('TUBITAK') && contrib.includes('TUBITAK')) ||
                 (normalized.includes('JASSP') && contrib.includes('JASSP')) ||
                 (normalized.includes('JAPSS') && contrib.includes('JAPSS'));
        });
      });
  };

  // Fonction pour créer des icônes personnalisées pour les partenaires
  const createCustomIcon = (partner, isSelected = false) => {
    const isCoordinator = partner.isCoordinator || false;
    return L.divIcon({
      html: `
        <div style="
          width: ${isSelected ? '80px' : '60px'};
          height: ${isSelected ? '80px' : '60px'};
          border-radius: 50%;
          background: linear-gradient(135deg, ${partner.color}, ${partner.color}dd);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: ${isSelected ? '2.5rem' : '2rem'};
          color: white;
          border: 4px solid white;
          box-shadow: ${isSelected ? '0 15px 40px rgba(0,0,0,0.4), 0 0 30px ' + partner.color + '80' : '0 8px 25px rgba(0,0,0,0.3)'};
          transform: ${isSelected ? 'scale(1.2)' : 'scale(1)'};
          transition: all 0.3s ease;
          position: relative;
          overflow: visible;
          ${isSelected ? 'animation: pulse 2s infinite;' : ''}
        ">
          <div style="
            width: 100%;
            height: 100%;
            border-radius: 50%;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: ${isSelected ? '0.9rem' : '0.75rem'};
            font-weight: 700;
            text-align: center;
            padding: 4px;
            word-wrap: break-word;
            line-height: 1.1;
          ">
            ${partner.name}
          </div>
          ${isSelected ? '' : ''}
          ${isCoordinator ? `<div style="position:absolute; top:-8px; right:-8px; background:#ffd700; color:#2c3e50; font-weight:700; font-size:.65rem; padding:3px 7px; border-radius:12px; z-index:1000; box-shadow:0 2px 8px rgba(0,0,0,0.3); white-space:nowrap; border:2px solid #fff;">${t('partners.map.coordShort', 'Coord.')}</div>` : ''}
        </div>
      `,
      className: 'custom-partner-icon',
      iconSize: [isSelected ? 80 : 60, isSelected ? 80 : 60],
      iconAnchor: [isSelected ? 40 : 30, isSelected ? 40 : 30],
    });
  };

  // Initialisation de la carte Leaflet
  useEffect(() => {
    if (!mapRef.current || partnersLoading || !partners.length) return;

    // Nettoyer la carte existante si elle existe
    if (mapInstance.current) {
      mapInstance.current.remove();
      mapInstance.current = null;
    }

    // Créer la nouvelle carte
    mapInstance.current = L.map(mapRef.current, {
      center: [40, 10], // Centre sur la Méditerranée
      zoom: 4,
       zoomControl: !isMobile, // Pas de contrôle de zoom sur mobile
       scrollWheelZoom: !isMobile, // Pas de zoom avec la molette sur mobile
       doubleClickZoom: !isMobile, // Pas de zoom double-clic sur mobile
       boxZoom: !isMobile, // Pas de zoom par sélection sur mobile
       keyboard: !isMobile, // Pas de contrôle clavier sur mobile
       dragging: !isMobile, // Pas de déplacement sur mobile
       touchZoom: !isMobile, // Pas de zoom tactile sur mobile
       tap: !isMobile // Pas de tap sur mobile
    });

    // Ajouter la couche de tuiles OpenStreetMap
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 18,
      minZoom: 3
    }).addTo(mapInstance.current);

    // Ajouter une couche de style pour les pays
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
      attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
      maxZoom: 18,
      minZoom: 3,
      opacity: 0.7
    }).addTo(mapInstance.current);

    // Expose helper for popup template
    // eslint-disable-next-line no-underscore-dangle
    window.__getLeadWPsForPartner = (partnerName) => getLeadWPsForPartner ? getLeadWPsForPartner(partnerName) : [];

    // Ajouter les marqueurs des partenaires
    partners.forEach((partner) => {
      const marker = L.marker(partner.coordinates, {
        icon: createCustomIcon(partner)
      }).addTo(mapInstance.current);

      // Popup avec informations basiques - utiliser les données de la base
      const leadWPs = partner.workPackagesLead || [];
      const contribWPs = partner.workPackagesContributing || [];
      const leadCodesStr = leadWPs.map(wp => typeof wp === 'string' ? wp : wp.id).join(', ');
      const contribCodesStr = contribWPs.map(wp => typeof wp === 'string' ? wp : wp.id).join(', ');
      // Logo pour le popup - utiliser logoUrl si disponible, sinon emoji
      const logoHtml = partner.logoUrl 
        ? `<img src="${partner.logoUrl}" alt="${partner.name}" style="width: 48px; height: 48px; object-fit: contain; border-radius: 6px; margin-right: 10px; background: rgba(255,255,255,0.9); padding: 4px;" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" /><div style="font-size: 2rem; margin-right: 10px; display: none;">${partner.logo || '🏢'}</div>`
        : `<div style="font-size: 2rem; margin-right: 10px;">${partner.logo || '🏢'}</div>`;
      
      const popupContent = `
        <div style="font-family: Arial, sans-serif; max-width: 320px;">
          <div style="display: flex; align-items: center; margin-bottom: 8px;">
            ${logoHtml}
            <div>
              <h3 style="margin: 0; color: ${partner.color}; font-size: 1.05rem; font-weight: 700; letter-spacing: .2px;">
                ${partner.name ? `<span style='margin-right:6px;'>${partner.name}</span>` : ''}
                <span style="font-weight:600; color:#2c3e50;">${partner.fullName}</span>
              </h3>
              <p style="margin: 3px 0 0 0; font-size: 0.9rem; color: #666;">${partner.country}</p>
              ${partner.piName ? `<p style="margin: 3px 0 0 0; font-size: 0.85rem; color: #888; font-style: italic;">${t('home.consortium.principalInvestigator', 'PI')}: ${partner.piName}</p>` : ''}
            </div>
          </div>
          ${leadCodesStr ? `<p style=\"margin: 6px 0 2px 0; font-size: 0.9rem; color: #333;\"><strong>${t('home.consortium.leadLabel')}</strong> ${leadCodesStr}</p>` : ''}
          ${contribCodesStr ? `<p style=\"margin: 0 0 8px 0; font-size: .9rem; color:#6c757d;\"><strong>${t('home.consortium.contributingLabel')}</strong> ${contribCodesStr}</p>` : ''}
          <button data-partner-id="${partner.id}" style="
            background: ${partner.color};
            color: white;
            border: none;
            padding: 6px 10px;
            border-radius: 5px;
            cursor: pointer;
            font-weight: 700;
            font-size: 0.7rem;
            letter-spacing: .2px;
          ">${t('home.consortium.viewDetails')}</button>
        </div>
      `;

      marker.bindPopup(popupContent);

      // Ajouter un gestionnaire d'événements pour le bouton dans le popup
      marker.on('popupopen', () => {
        const popup = marker.getPopup();
        const popupElement = popup.getElement();
        if (popupElement) {
          const button = popupElement.querySelector(`button[data-partner-id="${partner.id}"]`);
          if (button) {
            button.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              setSelectedPartner(partner.id);
              mapInstance.current.closePopup();
              
              // Scroll automatique vers les informations du partenaire - SEULEMENT SUR MOBILE
              setTimeout(() => {
                // Vérifier si c'est mobile
                const isMobile = window.innerWidth <= 768;
                
                if (isMobile) {
                  // Trouver la section des informations du partenaire sélectionné
                  const partnerInfo = document.querySelector('.partner-details-container');
                  if (partnerInfo) {
                    // Scroll EN DESSOUS avec scrollBy (vers le bas)
                    window.scrollBy({
                      top: 700, // Scroll 500px vers le bas
                      behavior: 'smooth'
                    });
                  } else {
                    // Si pas trouvé, aller vers la section des détails du partenaire
                    const partnerDetails = document.querySelector('[style*="flex: 1"]');
                    if (partnerDetails) {
                      // Scroll EN DESSOUS avec scrollBy (vers le bas)
                      window.scrollBy({
                        top: 700, // Scroll 500px vers le bas
                        behavior: 'smooth'
                      });
                    }
                  }
                }
                // Sur desktop, pas de scroll automatique
              }, 300);
            });
          }
        }
      });

      // Gestion des événements
      marker.on('contextmenu', (e) => {
        e.originalEvent.preventDefault(); // Empêcher le menu contextuel par défaut
        setSelectedPartner(partner.id);
        // Mettre à jour l'icône pour montrer qu'elle est sélectionnée
        marker.setIcon(createCustomIcon(partner, true));
      });

      marker.on('popupclose', () => {
        if (selectedPartner !== partner.id) {
          marker.setIcon(createCustomIcon(partner, false));
        }
      });
    });

    // Ajuster la vue pour montrer tous les partenaires
    if (partners.length > 0) {
      const group = new L.featureGroup(partners.map(p => L.marker(p.coordinates || [40, 10])));
    mapInstance.current.fitBounds(group.getBounds().pad(0.1));
    }

    setMapLoading(false);

    // Assurer le redimensionnement correct
    setTimeout(() => { try { mapInstance.current && mapInstance.current.invalidateSize(); } catch(_){} }, 50);

    // Fonction de nettoyage
    return () => {
      if (mapInstance.current) {
        mapInstance.current.remove();
        mapInstance.current = null;
      }
    };
  }, [partnersData, partnersLoading]);

  // Recalculer la taille de la carte au redimensionnement
  useEffect(() => {
    let resizeTimer = null;
    const fitToPartners = () => {
      try {
        if (!mapInstance.current) return;
        mapInstance.current.invalidateSize();
        if (partners.length > 0) {
          const bounds = new L.featureGroup(partners.map(p => L.marker(p.coordinates || [40, 10]))).getBounds().pad(0.1);
        mapInstance.current.fitBounds(bounds, { animate: false });
        }
      } catch(_){}
    };
    const onResize = () => {
      setViewportWidth(window.innerWidth);
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fitToPartners, 120);
    };
    const onOrientation = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fitToPartners, 120);
    };
    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(fitToPartners, 120);
      }
    };
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onOrientation);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onOrientation);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [isMobile, partners]);

  // Fonction globale pour sélectionner un partenaire (appelée depuis le popup)
  useEffect(() => {
    window.selectPartner = (partnerId) => {
      setSelectedPartner(partnerId);
    };
  }, []);

  return (
    <div className=" fade-in-up" style={{
      minHeight: '100vh',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }}>
      <div style={{
        maxWidth: '1600px',
        margin: '0 auto',
      }}>
      

        {/* Main Content Layout */}
        <div className="medagricycle-layout" style={{
          display: 'flex',
          gap: '30px',
          alignItems: 'stretch',
          minHeight: '100vh',
          flexDirection: isMobile ? 'column' : 'row'
        }}>
          {/* Left Section - Map */}
          <div className="map-container-enhanced glass-morphism" style={{
            flex: '1',
            background: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '25px',
            position: 'relative',
            minHeight: '100vh'
          }}>
            {/* Loading Indicator */}
            {mapLoading && (
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 1000,
                textAlign: 'center',
                color: '#2c3e50'
              }}>
                <div style={{
                  fontSize: '4rem',
                  marginBottom: '20px',
                  animation: 'spin 2s linear infinite'
                }}>
                  🌍
                </div>
                <div style={{
                  fontSize: '1.4rem',
                  fontWeight: 'bold',
                  color: '#667eea'
                }}>
                  {t('home.consortium.loadingMap')}
                </div>
                <div style={{
                  fontSize: '0.9rem',
                  color: '#7f8c8d',
                  marginTop: '10px'
                }}>
                  {t('home.map.title')}
                </div>
              </div>
            )}

            {/* Map Container */}
            <div
              ref={mapRef}
              style={{
                width: '100%',
                height: '100vh',
                borderRadius: '15px',
                position: 'relative',
                zIndex: 10,
                boxShadow: 'inset 0 0 20px rgba(0,0,0,0.1)'
              }}
            />

           
          </div>

          {/* Right Section - Partner Details */}
          <div className="partner-details-panel glass-morphism" style={{
            width: isMobile ? '100%' : '450px',
            background: selectedPartner ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.8)',
            borderRadius: '25px',
            padding: '30px',
            overflow: 'auto',
            maxHeight: isMobile ? 'unset' : '800px',
            transition: 'all 0.3s ease'
          }}>
            {selectedPartner ? (
              (() => {
                const partner = partners.find(p => p.id === selectedPartner);
                if (!partner) return null;

                return (
                  <div style={{ height: '100%' }}>
                    {/* Partner Header */}
                    <div style={{
                      textAlign: 'center',
                      marginBottom: '25px',
                      paddingBottom: '20px',
                      borderBottom: `2px solid ${partner.color}40`,
                      position: 'relative'
                    }}>
                      {/* Bouton fermer */}
                      <button
                        onClick={() => setSelectedPartner(null)}
                        style={{
                          position: 'absolute',
                          top: '0',
                          right: '0',
                          background: 'rgba(255, 255, 255, 0.9)',
                          border: 'none',
                          borderRadius: '50%',
                          width: '40px',
                          height: '40px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          fontSize: '20px',
                          color: '#e74c3c',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                          transition: 'all 0.3s ease',
                          zIndex: 10
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background = '#e74c3c';
                          e.target.style.color = 'white';
                          e.target.style.transform = 'scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = 'rgba(255, 255, 255, 0.9)';
                          e.target.style.color = '#e74c3c';
                          e.target.style.transform = 'scale(1)';
                        }}
                      >
                        ✕
                      </button>
                      <div style={{
                        marginBottom: '15px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}>
                        {partner.logoUrl ? (
                          <img 
                            src={partner.logoUrl} 
                            alt={partner.name}
                            style={{
                              width: '120px',
                              height: '120px',
                              objectFit: 'contain',
                              borderRadius: '12px',
                              boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                              backgroundColor: 'rgba(255, 255, 255, 0.9)',
                              padding: '10px'
                            }}
                            onError={(e) => {
                              // Fallback vers l'emoji si l'image ne charge pas
                              e.target.style.display = 'none';
                              const emojiDiv = e.target.nextElementSibling;
                              if (emojiDiv) {
                                emojiDiv.style.display = 'block';
                              }
                            }}
                          />
                        ) : null}
                        <div style={{
                          fontSize: '4.5rem',
                        color: partner.color,
                          textShadow: '0 2px 8px rgba(0,0,0,0.2)',
                          display: partner.logoUrl ? 'none' : 'block'
                      }}>
                          {partner.logo || '🏢'}
                        </div>
                      </div>
                      <h2 style={{
                        margin: '0 0 8px 0',
                        color: '#2c3e50',
                        fontSize: '2.2rem',
                        fontWeight: 'bold',
                        lineHeight: '1.2'
                      }}>
                        {partner.name}
                      </h2>
                      <p style={{
                        margin: '0 0 15px 0',
                        color: '#7f8c8d',
                        fontSize: '1.1rem',
                        fontWeight: '500'
                      }}>
                        {partner.fullName}
                      </p>
                      {partner.piName && (
                        <p style={{
                          margin: '0 0 15px 0',
                          color: '#5a6c7d',
                          fontSize: '1rem',
                          fontWeight: '400',
                          fontStyle: 'italic'
                        }}>
                          <i className="fas fa-user" style={{ marginRight: '8px', color: partner.color }} />
                          {t('home.consortium.principalInvestigator', 'Principal Investigator')}: {partner.piName}
                        </p>
                      )}
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '15px',
                        flexWrap: 'wrap'
                      }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          background: `${partner.color}20`,
                          padding: '8px 15px',
                          borderRadius: '25px',
                          border: `1px solid ${partner.color}40`
                        }}>
                          <span style={{
                            color: partner.color,
                            fontSize: '0.95rem',
                            fontWeight: 'bold'
                          }}>
                            {partner.country}
                          </span>
                        </div>
                        {partner.website && partner.website !== '#' ? (
                          <a href={partner.website} target="_blank" rel="noopener noreferrer" style={{
                            background: partner.color,
                            color: 'white',
                            padding: '6px 12px',
                            borderRadius: '15px',
                            fontSize: '0.8rem',
                            fontWeight: 'bold',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                            textDecoration: 'none'
                          }}>
                            {t('home.consortium.visitWebsite')}
                          </a>
                        ) : null}
                      </div>
                    </div>

                    {/* Partner Information */}
                    <div style={{ flex: 1 }}>
                      {/* Work Package */}
                      <div style={{
                        background: `linear-gradient(135deg, ${partner.color}15, ${partner.color}25)`,
                        padding: '20px',
                        borderRadius: '15px',
                        marginBottom: '20px',
                        border: `1px solid ${partner.color}30`
                      }}>
                      
                        {(() => {
                          // Use work packages from database if available, otherwise calculate from wpAssignments (fallback)
                          const leads = partner.workPackagesLead && partner.workPackagesLead.length > 0 
                            ? partner.workPackagesLead 
                            : getLeadWPsForPartner(partner.name).map(key => ({
                                id: key,
                                title: wpMeta[key]?.title || '',
                                lead: wpMeta[key]?.lead || '',
                                type: 'Lead'
                              }));
                          
                          const contribs = partner.workPackagesContributing && partner.workPackagesContributing.length > 0
                            ? partner.workPackagesContributing
                            : getContribWPsForPartner(partner.name).map(key => ({
                                id: key,
                                title: wpMeta[key]?.title || '',
                                lead: wpMeta[key]?.lead || '',
                                type: 'Contributing partner'
                              }));
                          
                          if (!leads.length && !contribs.length) return null;
                          return (
                            <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px', marginBottom: '10px' }}>
                              {leads.length > 0 ? (
                                <div>
                                  <div style={{ color: partner.color, fontWeight: 700, margin: '0 0 6px 0', fontSize: '.95rem' }}>{t('home.consortium.lead')}</div>
                                  <div style={{ display: 'flex', flexDirection: 'column', rowGap: '6px' }}>
                                    {leads.map((wp) => {
                                      // Handle both object format (from DB) and string format (fallback)
                                      const wpId = typeof wp === 'string' ? wp : wp.id;
                                      const wpTitle = typeof wp === 'string' ? (wpMeta[wp]?.title || '') : (wp.title || wpMeta[wpId]?.title || '');
                                      const wpLead = typeof wp === 'string' ? (wpMeta[wp]?.lead || '') : (wp.lead || wpMeta[wpId]?.lead || '');
                                      
                                      if (!wpId) return null;
                                      return (
                                        <div key={wpId} style={{
                                          background: 'rgba(255,255,255,0.85)',
                                          border: '1px solid #e9ecef',
                                          borderRadius: '8px',
                                          padding: '8px'
                                        }}>
                                          <div style={{ fontWeight: 700, color: '#2c3e50' }}>{wpId}{wpTitle ? ` — ${wpTitle}` : ''}</div>
                                          {wpLead && (
                                            <div style={{ color: '#6c757d', fontSize: '.9rem' }}>{t('home.consortium.leadLabel')} {wpLead}</div>
                                          )}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              ) : null}
                              {contribs.length > 0 ? (
                                <div>
                                  <div style={{ color: '#6c757d', fontWeight: 700, margin: '4px 0 6px 0', fontSize: '.95rem' }}>{t('home.consortium.contributing')}</div>
                                  <div style={{ display: 'flex', flexDirection: 'column', rowGap: '6px' }}>
                                    {contribs.map((wp) => {
                                      // Handle both object format (from DB) and string format (fallback)
                                      const wpId = typeof wp === 'string' ? wp : wp.id;
                                      const wpTitle = typeof wp === 'string' ? (wpMeta[wp]?.title || '') : (wp.title || wpMeta[wpId]?.title || '');
                                      const wpType = typeof wp === 'string' ? t('home.consortium.contributingPartner') : (wp.type || t('home.consortium.contributingPartner'));
                                      
                                      if (!wpId) return null;
                                      return (
                                        <div key={`c-${wpId}`} style={{
                                          background: 'rgba(255,255,255,0.85)',
                                          border: '1px solid #e9ecef',
                                          borderRadius: '8px',
                                          padding: '8px'
                                        }}>
                                          <div style={{ fontWeight: 700, color: '#2c3e50' }}>{wpId}{wpTitle ? ` — ${wpTitle}` : ''}</div>
                                          <div style={{ color: '#6c757d', fontSize: '.9rem' }}>{wpType}</div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          );
                        })()}
                        {/* Core Expertise removed */}
                      </div>

                      {/* Role in Consortium removed */}
                    </div>
                  </div>
                );
              })()
            ) : (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                textAlign: 'center',
                color: '#7f8c8d'
              }}>
                <div style={{
                  fontSize: '4rem',
                  marginBottom: '20px',
                  opacity: 0.5
                }}>
                  👆
                </div>
                <h3 style={{
                  margin: '0 0 15px 0',
                  fontSize: '1.5rem',
                  color: '#2c3e50',
                  cursor: 'default'
                }}>
                  {t('home.consortium.selectPartner')}
                </h3>
                <div style={{
                  margin: 0,
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  maxWidth: '300px'
                }}>
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    padding: '12px',
                    borderRadius: '10px',
                    marginBottom: '10px',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                  }}>
                    <strong>{t('home.consortium.map')}</strong> {t('home.consortium.mapInstruction')}
                  </div>
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    padding: '12px',
                    borderRadius: '10px',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                  }}>
                    <strong>{t('home.consortium.badges')}</strong> {t('home.consortium.badgesInstruction')}
                  </div>
                </div>
                <div style={{
                  marginTop: '20px',
                  display: 'flex',
                  gap: '10px',
                  flexWrap: 'wrap',
                  justifyContent: 'center'
                }}>
                  {partners.map(partner => (
                    <div
                      key={partner.id}
                      onClick={(e) => {
                        // Animation de ripple
                        const ripple = document.createElement('span');
                        ripple.style.position = 'absolute';
                        ripple.style.borderRadius = '50%';
                        ripple.style.background = 'rgba(255, 255, 255, 0.6)';
                        ripple.style.transform = 'scale(0)';
                        ripple.style.animation = 'ripple 0.6s linear';
                        ripple.style.left = '50%';
                        ripple.style.top = '50%';
                        ripple.style.width = '20px';
                        ripple.style.height = '20px';
                        ripple.style.marginLeft = '-10px';
                        ripple.style.marginTop = '-10px';
                        e.target.appendChild(ripple);

                        setTimeout(() => {
                          ripple.remove();
                        }, 600);

                        setSelectedPartner(partner.id);

                        // Animation de succès
                        const successIcon = document.createElement('span');
                        successIcon.textContent = '✅';
                        successIcon.style.position = 'absolute';
                        successIcon.style.right = '8px';
                        successIcon.style.top = '50%';
                        successIcon.style.transform = 'translateY(-50%) scale(0)';
                        successIcon.style.animation = 'successPulse 0.5s ease-out';
                        successIcon.style.fontSize = '0.8rem';
                        successIcon.style.zIndex = '10';

                        e.target.appendChild(successIcon);

                        setTimeout(() => {
                          successIcon.remove();
                        }, 1000);
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        background: selectedPartner === partner.id ? `${partner.color}30` : `${partner.color}20`,
                        padding: '10px 15px',
                        borderRadius: '25px',
                        fontSize: '0.85rem',
                        color: partner.color,
                        fontWeight: selectedPartner === partner.id ? '700' : '600',
                        cursor: 'pointer',
                        border: `2px solid ${selectedPartner === partner.id ? partner.color : `${partner.color}30`}`,
                        transition: 'all 0.3s ease',
                        transform: selectedPartner === partner.id ? 'scale(1.05)' : 'scale(1)',
                        position: 'relative',
                        overflow: 'hidden'
                      }}
                      onMouseEnter={(e) => {
                        if (selectedPartner !== partner.id) {
                          e.target.style.transform = 'scale(1.05)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (selectedPartner !== partner.id) {
                          e.target.style.transform = 'scale(1)';
                        }
                      }}
                    >
                      <span>{partner.name.split(' ')[0]}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

     
      </div>
    </div>
  );
};

export default Home;
 
// LatestNews component (shows only 3 latest news, no pagination)
function LatestNews() {
  const { t } = useTranslation();
  const listRef = React.useRef(null);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isMobile, setIsMobile] = React.useState(false);
  const [allNews, setAllNews] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Detect mobile and handle pagination
  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Force re-render when mobile detection changes
  React.useEffect(() => {
    // This will trigger a re-render when isMobile changes
  }, [isMobile]);

  // Function to map category names to News page categories
  const mapCategoryToNewsCategory = (category) => {
    // Normaliser la catégorie en minuscules pour le filtrage
    return (category || '').toLowerCase().trim();
  };

  const handleCategoryClick = (category) => {
    const newsCategory = mapCategoryToNewsCategory(category);
    navigate(`/news?category=${newsCategory}`);
  };

  // Récupérer les news depuis l'API
  React.useEffect(() => {
    const fetchNews = async () => {
      setIsLoading(true);
      try {
        // Récupérer seulement les news publiées
        const newsData = await getNews({ status: 'Publié' });
        
        // Transformer les données pour correspondre au format attendu
        const transformedNews = newsData.map(news => {
          // Obtenir l'image (image_url ou image_file_path ou premier média image)
          let imageUrl = news.image_url;
          if (!imageUrl && news.image_file_path) {
            imageUrl = getFileUrl(news.image_file_path);
          }
          if (!imageUrl && news.media && news.media.length > 0) {
            const firstImage = news.media.find(m => m.media_type === 'image');
            if (firstImage) {
              imageUrl = firstImage.url ? getFileUrl(firstImage.url) : getFileUrl(firstImage.file_path);
            }
          }
          
          // Utiliser les catégories originales de la base de données
          const categories = news.categories || [];
          
          return {
            id: news.id,
            title: news.title,
            date: news.created_at || news.date,
            image: imageUrl || img1, // Utiliser une image par défaut
            link: `/news/${news.id}`,
            excerpt: news.content ? getExcerpt(news.content, 150) : '',
            categories: categories
          };
        });
        
        setAllNews(transformedNews);
      } catch (error) {
        setAllNews([]); // Utiliser un tableau vide en cas d'erreur
      } finally {
        setIsLoading(false);
      }
    };

    fetchNews();
  }, []);

  const formatDate = (iso) => {
    if (!iso) return '';
    // Si c'est déjà au format YYYY-MM-DD, le retourner tel quel
    if (typeof iso === 'string' && iso.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return iso;
    }
    // Sinon, parser la date et extraire seulement la partie date
    const date = new Date(iso);
    if (isNaN(date.getTime())) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Pagination logic - Mobile: 3 pages with 1 news each, Web: 3 news at once
  const sortedNews = allNews.slice().sort((a, b) => new Date(b.date) - new Date(a.date));
  const itemsPerPage = isMobile ? 1 : 3;
  const maxItemsToShow = 3; // Maximum 3 news à afficher
  const totalPages = isMobile ? Math.min(3, Math.ceil(sortedNews.length / itemsPerPage)) : 1; // Mobile: max 3 pages, Web: 1 page
  const startIndex = isMobile ? (currentPage - 1) * itemsPerPage : 0;
  const endIndex = isMobile ? startIndex + itemsPerPage : maxItemsToShow;
  const currentNews = sortedNews.slice(startIndex, endIndex);

  // Animate cards on scroll into view
  React.useEffect(() => {
    if (!listRef.current) return;
    const cards = listRef.current.querySelectorAll('.jet-posts__item');
    cards.forEach((el) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 400ms ease, transform 400ms ease';
    });

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    cards.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [currentNews]);

  // Afficher un message de chargement
  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <p>{t('home.news.loading')}</p>
      </div>
    );
  }

  return (
    <div className="latest-news-section">
      <div className="elementor-jet-posts jet-elements">
        <div ref={listRef} className="jet-posts col-row" style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
          {currentNews.map(item => (
            <div key={item.id} className="jet-posts__item" style={{ flex: '1 1 300px', maxWidth: '400px' }}>
              <div
                className="jet-posts__inner-box"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  background: '#fff',
                  border: '2px solid #e5e7eb',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                  height: '520px',
                  transform: 'translateY(0)',
                  transition: 'all 0.3s ease',
                  cursor: 'default',
                  position: 'relative'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#96ca2d';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(150, 202, 45, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e5e7eb';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
                }}
              >
                {/* Barre verte en haut */}
                <div style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  right: '0px',
                  height: '3px',
                  background: 'linear-gradient(135deg, rgb(150, 202, 45) 0%, rgb(127, 184, 0) 100%)',
                  transform: 'translateY(0px)',
                  borderColor: 'rgba(150, 202, 45, 0.1)',
                  zIndex: 2
                }} />
                <div className="post-thumbnail" style={{ height: '180px', overflow: 'hidden', position: 'relative', flex: '0 0 180px' }}>
                  <div
                    aria-label={item.title}
                    className="post-thumbnail__link"
                    style={{ display: 'block', position: 'relative', height: '100%' }}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease'
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.05)'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                    />
                    {/* Catégories sur l'image */}
                    {item.categories && item.categories.length > 0 && (
                      <div style={{ 
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        display: 'inline-flex',
                        gap: '6px',
                        flexWrap: 'wrap',
                        zIndex: 2,
                        pointerEvents: 'none'
                      }}>
                        {item.categories.map((category, index) => {
                          // Utiliser le nom original normalisé en minuscules pour le filtrage
                          const categoryName = typeof category === 'string' ? category : (category.category || category.name || category);
                          const categoryIdForFilter = (categoryName || '').toLowerCase().trim();
                          return (
                            <span
                              key={index}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                scrollToTop();
                                handleCategoryClick(categoryIdForFilter);
                              }}
                              style={{
                                background: 'rgb(150, 202, 45)',
                                color: 'rgb(255, 255, 255)',
                                padding: '12px 14px',
                                borderRadius: '20px',
                                fontSize: '0.9rem',
                                fontWeight: 700,
                                letterSpacing: '0.5px',
                                backdropFilter: 'blur(4px)',
                                boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 8px',
                                cursor: 'pointer',
                                pointerEvents: 'auto',
                                transition: 'all 0.3s ease'
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.transform = 'scale(1.05)';
                                e.target.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 4px 12px';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.transform = 'scale(1)';
                                e.target.style.boxShadow = 'rgba(0, 0, 0, 0.2) 0px 2px 8px';
                              }}
                            >
                              {categoryName}
                            </span>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
                <div className="jet-posts__inner-content" style={{ 
                  padding: '25px', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: '15px', 
                  flex: 1, 
                  height: '320px', 
                  justifyContent: 'space-between' 
                }}>
                  <div style={{ height: '2.4rem', minHeight: '2.4rem', maxHeight: '2.4rem', display: 'flex', alignItems: 'center' }}>
                    <h4 className="entry-title" style={{ margin: 0, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '1.1rem', fontWeight: 'bold' }} title={item.title}>
                      <span style={{ color: '#2c3e50' }}>{item.title}</span>
                    </h4>
                  </div>
                  <div style={{ height: '1.5rem', minHeight: '1.5rem', maxHeight: '1.5rem', display: 'flex', alignItems: 'center' }}>
                    <div className="post-meta" style={{ color: '#7f8c8d', fontSize: '0.9rem', margin: 0 }}>
                    <time dateTime={item.date} title={item.date} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <i className="fas fa-calendar-alt" style={{ fontSize: '0.85rem', color: '#7f8c8d' }}></i>
                      <span>{formatDate(item.date)}</span>
                    </time>
                  </div>
                  </div>
                  <div style={{ height: '4.8rem', minHeight: '4.8rem', maxHeight: '4.8rem', display: 'flex', alignItems: 'flex-start' }}>
                  <div className="entry-excerpt" title={item.excerpt} style={{ 
                    color: '#34495e', 
                    fontSize: '0.95rem', 
                    lineHeight: 1.6, 
                      margin: 0
                    }}>
                      {item.excerpt.length > 110 ? item.excerpt.substring(0, 110) + '...' : item.excerpt}
                  </div>
                  </div>
                  <div className="jet-more-wrap" style={{ height: '2.5rem', minHeight: '2.5rem', maxHeight: '2.5rem', display: 'flex', alignItems: 'center', margin: 0 }}>
                    <a
                      href="#"
                      onClick={(e) => { e.preventDefault(); scrollToTop(); navigate(`/news/${item.id}`); }}
                      className="btn btn-primary elementor-button  elementor-size-md jet-more"
                      style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '10px 20px', borderRadius: '25px', background: '#96ca2d', color: '#fff', textDecoration: 'none', fontWeight: '600', fontSize: '0.9rem', transition: 'all 0.3s ease' }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#fff';
                        e.currentTarget.style.color = '#96ca2d';
                        e.currentTarget.style.border = '1px solid #96ca2d';
                        e.currentTarget.style.transform = 'translateX(5px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#96ca2d';
                        e.currentTarget.style.color = '#fff';
                        e.currentTarget.style.border = 'none';
                        e.currentTarget.style.transform = 'translateX(0)';
                      }}
                    >
                      <span className="btn__text">{t('home.news.readMore')}</span>
                      <i className="fas fa-arrow-right" style={{ transition: 'transform 0.3s ease' }}></i>

                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>

        {/* Pagination Controls - Only on mobile */}
        {isMobile && totalPages > 1 && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '15px',
            marginTop: '30px',
            padding: '20px 0',
            backgroundColor: '#f8f9fa',
            borderRadius: '10px',
            margin: '20px 10px'
          }}>
            <button
              onClick={() => {
                setCurrentPage(Math.max(1, currentPage - 1));
              }}
              disabled={currentPage === 1}
              style={{
                padding: '12px',
                background: currentPage === 1 ? '#e0e0e0' : '#96ca2d',
                color: currentPage === 1 ? '#999' : 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                fontSize: '20px',
                fontWeight: '600',
                transition: 'all 0.3s ease',
                opacity: currentPage === 1 ? 0.5 : 1,
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {'<'}
            </button>
            
            <button
              onClick={() => {
                setCurrentPage(Math.min(totalPages, currentPage + 1));
              }}
              disabled={currentPage === totalPages}
              style={{
                padding: '12px',
                background: currentPage === totalPages ? '#e0e0e0' : '#96ca2d',
                color: currentPage === totalPages ? '#999' : 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                fontSize: '20px',
                fontWeight: '600',
                transition: 'all 0.3s ease',
                opacity: currentPage === totalPages ? 0.5 : 1,
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {'>'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// LatestEvents component (shows only 3 latest events, no pagination)
function LatestEvents() {
  const { t } = useTranslation();
  const listRef = React.useRef(null);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isMobile, setIsMobile] = React.useState(false);
  const [allEvents, setAllEvents] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Detect mobile and handle pagination
  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Force re-render when mobile detection changes
  React.useEffect(() => {
    // This will trigger a re-render when isMobile changes
  }, [isMobile]);
  // Récupérer les événements depuis l'API
  React.useEffect(() => {
    const fetchEvents = async () => {
      setIsLoading(true);
      try {
        // Récupérer seulement les événements publiés
        const eventsData = await getEvents({ status: 'Publié' });
        
        // Transformer les données pour correspondre au format attendu
        const transformedEvents = eventsData.map(event => {
          // Obtenir l'image (image_url ou image_file_path ou premier média image)
          let imageUrl = event.image_url;
          if (!imageUrl && event.image_file_path) {
            imageUrl = getFileUrl(event.image_file_path);
          }
          if (!imageUrl && event.media && event.media.length > 0) {
            const firstImage = event.media.find(m => m.media_type === 'image');
            if (firstImage) {
              imageUrl = firstImage.url ? getFileUrl(firstImage.url) : getFileUrl(firstImage.file_path);
            }
          }
          
          return {
            id: event.id,
            title: event.title,
            date: event.date || event.created_at,
            location: event.location || 'En ligne',
            image: imageUrl || img1, // Utiliser une image par défaut
            link: `/events/${event.id}`,
            excerpt: event.content ? getExcerpt(event.content, 150) : ''
          };
        });
        
        setAllEvents(transformedEvents);
      } catch (error) {
        setAllEvents([]); // Utiliser un tableau vide en cas d'erreur
      } finally {
        setIsLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const formatDate = (iso) => {
    if (!iso) return '';
    // Si c'est déjà au format YYYY-MM-DD, le retourner tel quel
    if (typeof iso === 'string' && iso.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return iso;
    }
    // Sinon, parser la date et extraire seulement la partie date
    const date = new Date(iso);
    if (isNaN(date.getTime())) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Pagination logic - Mobile: 3 pages with 1 event each, Web: 3 events at once
  const sortedEvents = allEvents.slice().sort((a, b) => new Date(b.date) - new Date(a.date));
  const itemsPerPage = isMobile ? 1 : 3;
  const maxItemsToShow = 3; // Maximum 3 événements à afficher
  const totalPages = isMobile ? Math.min(3, Math.ceil(sortedEvents.length / itemsPerPage)) : 1; // Mobile: max 3 pages, Web: 1 page
  const startIndex = isMobile ? (currentPage - 1) * itemsPerPage : 0;
  const endIndex = isMobile ? startIndex + itemsPerPage : maxItemsToShow;
  const currentEvents = sortedEvents.slice(startIndex, endIndex);

  // Animate cards on scroll into view
  React.useEffect(() => {
    if (!listRef.current) return;
    const cards = listRef.current.querySelectorAll('.jet-posts__item');
    cards.forEach((el) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 400ms ease, transform 400ms ease';
    });

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    cards.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [currentEvents]);

  // Afficher un message de chargement
  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <p>{t('home.events.loading')}</p>
      </div>
    );
  }

  return (
    <div className="latest-events-section">
      <div className="elementor-jet-posts jet-elements">
        <div ref={listRef} className="jet-posts col-row" style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
          {currentEvents.map(item => (
            <div key={item.id} className="jet-posts__item" style={{ flex: '1 1 300px', maxWidth: '400px' }}>
              <div
                className="jet-posts__inner-box"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  background: '#fff',
                  border: '2px solid #e5e7eb',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                  height: '520px',
                  transform: 'translateY(0)',
                  transition: 'all 0.3s ease',
                  cursor: 'default',
                  position: 'relative'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#96ca2d';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(150, 202, 45, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e5e7eb';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
                }}
              >
                {/* Barre verte en haut */}
                <div style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  right: '0px',
                  height: '3px',
                  background: 'linear-gradient(135deg, rgb(150, 202, 45) 0%, rgb(127, 184, 0) 100%)',
                  transform: 'translateY(0px)',
                  borderColor: 'rgba(150, 202, 45, 0.1)',
                  zIndex: 2
                }} />
                <div className="post-thumbnail" style={{ height: '180px', overflow: 'hidden', position: 'relative', flex: '0 0 180px' }}>
                  <div
                    aria-label={item.title}
                    className="post-thumbnail__link"
                    style={{ display: 'block', position: 'relative', height: '100%' }}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease'
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.05)'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                    />
                  </div>
                </div>
                <div className="jet-posts__inner-content" style={{ 
                  padding: '25px', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: '15px', 
                  flex: 1, 
                  height: '320px', 
                  justifyContent: 'space-between' 
                }}>
                  <div style={{ height: '2.4rem', minHeight: '2.4rem', maxHeight: '2.4rem', display: 'flex', alignItems: 'center' }}>
                    <h4 className="entry-title" style={{ margin: 0, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '1.1rem', fontWeight: 'bold' }} title={item.title}>
                      <span style={{ color: '#2c3e50' }}>{item.title}</span>
                    </h4>
                  </div>
                  <div style={{ minHeight: '1.5rem', display: 'flex', alignItems: 'center' }}>
                    <div className="post-meta" style={{ color: '#7f8c8d', fontSize: '0.9rem', margin: 0, display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                      <time dateTime={item.date} title={item.date} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <i className="fas fa-calendar-alt" style={{ fontSize: '0.85rem', color: '#7f8c8d' }}></i>
                      <span>{formatDate(item.date)}</span>
                    </time>
                      {item.location && (
                        <span style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#96ca2d', fontWeight: '500' }}>
                          <i className="fas fa-map-marker-alt" style={{ fontSize: '0.85rem' }}></i>
                          <span>{item.location}</span>
                        </span>
                      )}
                    </div>
                  </div>
                  <div style={{ height: '4.8rem', minHeight: '4.8rem', maxHeight: '4.8rem', display: 'flex', alignItems: 'flex-start' }}>
                  <div className="entry-excerpt" title={item.excerpt} style={{ 
                    color: '#34495e', 
                    fontSize: '0.95rem', 
                    lineHeight: 1.6, 
                       margin: 0
                     }}>
                       {item.excerpt.length > 110 ? item.excerpt.substring(0, 110) + '...' : item.excerpt}
                  </div>
                  </div>
                  <div className="jet-more-wrap" style={{ height: '2.5rem', minHeight: '2.5rem', maxHeight: '2.5rem', display: 'flex', alignItems: 'center', margin: 0 }}>
                    <a
                      href="#"
                      onClick={(e) => { e.preventDefault(); scrollToTop(); navigate(`/events/${item.id}`); }}
                      className="btn btn-primary elementor-button elementor-size-md jet-more"
                      style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '10px 20px', borderRadius: '25px', background: '#96ca2d', color: '#fff', textDecoration: 'none', fontWeight: '600', fontSize: '0.9rem', transition: 'all 0.3s ease' }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#fff';
                        e.currentTarget.style.color = '#96ca2d';
                        e.currentTarget.style.border = '1px solid #96ca2d';
                        e.currentTarget.style.transform = 'translateX(5px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#96ca2d';
                        e.currentTarget.style.color = '#fff';
                        e.currentTarget.style.border = 'none';
                        e.currentTarget.style.transform = 'translateX(0)';
                      }}
                    >
                      <span className="btn__text">{t('home.events.readMore')}</span>
                      <i className="fas fa-arrow-right" style={{ transition: 'transform 0.3s ease' }}></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Pagination Controls - Only on mobile */}
        {isMobile && totalPages > 1 && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '15px',
            marginTop: '30px',
            padding: '20px 0',
          
            margin: '20px 10px'
          }}>
            <button
              onClick={() => {
                setCurrentPage(Math.max(1, currentPage - 1));
              }}
              disabled={currentPage === 1}
              style={{
                padding: '12px',
                background: currentPage === 1 ? '#e0e0e0' : '#96ca2d',
                color: currentPage === 1 ? '#999' : 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                fontSize: '20px',
                fontWeight: '600',
                transition: 'all 0.3s ease',
                opacity: currentPage === 1 ? 0.5 : 1,
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {'<'}
            </button>
            
            <button
              onClick={() => {
                setCurrentPage(Math.min(totalPages, currentPage + 1));
              }}
              disabled={currentPage === totalPages}
              style={{
                padding: '12px',
                background: currentPage === totalPages ? '#e0e0e0' : '#96ca2d',
                color: currentPage === totalPages ? '#999' : 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                fontSize: '20px',
                fontWeight: '600',
                transition: 'all 0.3s ease',
                opacity: currentPage === totalPages ? 0.5 : 1,
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {'>'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

